module.exports = __webpack_public_path__ + "img/loespejo-logo.d5b694f2.png";